import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/lab/Autocomplete";
import React from "react";
import {AutoCompleteSingleProps} from "./AutoCompleteProps";

const AutoCompleteSingle = ({id, options, label, disabled, value, setValue}: AutoCompleteSingleProps) => {
    return (
        <Autocomplete
            id={id}
            options={options}
            value={value}
            size="small"
            fullWidth
            disabled={disabled}
            onChange={(event: React.SyntheticEvent, newValue: string | null) =>
                setValue(newValue)
            }
            renderInput={(params) => <TextField {...params} label={label} variant="outlined"/>}
        />
    );
}
export default AutoCompleteSingle;
